import { render } from "./CookieTermsPage.vue?vue&type=template&id=5c221b35"
import script from "./CookieTermsPage.vue?vue&type=script&lang=js"
export * from "./CookieTermsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__